// extracted by mini-css-extract-plugin
export default {"formRow":"ProfileSettings_formRow__vVylX","formLabel":"ProfileSettings_formLabel__S5QuJ","button":"ProfileSettings_button__kgSSc"};